import { useTranslation } from 'hooks/useTranslation'
import Head from 'next/head'

import { Step1 } from 'features/MealPlan/screens/Step1'
import Script from 'next/script'
export default function MealPlan(props: {}) {
  const { t } = useTranslation()

  // prettier-ignore
  const schema = {
    '@context': 'https://schema.org',
    '@type': 'HowTo',
    name: "Meal Planning Step 1: Complete Your Pet's Profile",
    description: "Enter your pet's name, age, gender, and spayed/neutered status.",
    step: [
      {
        '@type': 'HowToStep',
        name: "Complete Your Pet's Profile",
        url: 'https://wefeedraw.com/meal-plan/step-1',
        itemListElement: [
          {
            '@type': 'HowToDirection',
            text: "What is your pet's name?"
          },
          {
            '@type': 'HowToDirection',
            text: 'How old is your pet?'
          },
          {
            '@type': 'HowToDirection',
            text: 'Is your pet male or female?'
          },
          {
            '@type': 'HowToDirection',
            text: 'Is she spayed?'
          },
          {
            '@type': 'HowToDirection',
            text: 'Is he neutered?'
          }
        ]
      }
    ]
  };

  const jsonLdString = JSON.stringify(schema)

  //used for wizard test. Keeping as future reference
  // const wizardSelector = useRef(props?.wizardSelector || null)
  // const [attempted, setAttempted] = useState(false)
  // const version = useVersion(setAttempted, attempted, wizardSelector)
  // useEffect(() => {
  //   try {
  //     const versionObj = version
  //     if (!versionObj) return
  //     if (versionObj['wizardSelector']) wizardSelector.current = versionObj['wizardSelector']
  //   } catch (err) {
  //     setAttempted(true)
  //   }
  // }, [version, attempted])
  // if (!attempted) return
  //end used for wizard test

  return (
    <div>
      <Head>
        <title>{t('meal-plan:step-1.page-title')}</title>
        <meta name="title" content={t('meal-plan:meta-title')} />
        <meta name="description" content={t('meal-plan:meta-description')} />
        <link rel="canonical" href="https://wefeedraw.com/meal-plan/step-1" />
      </Head>

      <main>
      <Script
        id="schema-script"
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: jsonLdString }}
      />
        <Step1 />
      </main>
    </div>
  )
}

// Keeping as future reference
// export const getServerSideProps: GetServerSideProps = async (ctx) => {
//   const cookies = new Cookies(ctx.req, ctx.res)
//   const wizardSelector = cookies.get(CookieKeys.WIZARD_FLAG) || null

//   return {
//     props: {
//       wizardSelector,
//     },
//   }
// }

//used for wizard test. Keeping as future reference
// const useVersion = (setAttempted: any, attempted: boolean, wizardSelector: any) => {
//   const [version, setVersion] = useState()
//   const [attempts, setAttempts] = useState(0)
//   useEffect(() => {
//     if (attempted) return
//     if (!!wizardSelector.current) {
//       //this means a cookie is found and we don't need to attmpet to get the version from storage
//       setAttempted(true)
//       return
//     }
//     const maxAttempts = 8
//     const intervalId = setInterval(() => {
//       setAttempts(attempts + 1)
//       if (maxAttempts < attempts) {
//         setAttempted(true)
//         clearInterval(intervalId)
//       }
//       if (window !== undefined) {
//         const version = Storage.get('VERSION_FLAG')
//         setVersion(version)
//         clearInterval(intervalId)
//       }
//     }, 100)
//   })
//   return version
// }
//end used for wizard test
